import React from 'react';
import './appheader.styles.css';
import { Header, Image, Segment } from 'semantic-ui-react';
import * as Constants from '../../utils/Constants';
import UserMessage from './usermessage.component';

const AppHeader = () => (
  <>
    <Segment clearing className='app-header header-prop'>
      <Header as='div' floated='left'>
        <Image
          src={Constants.mutualOfOmahaHeaderLogo}
          size='massive'
          className='app-logo'
        />
      </Header>
    </Segment>
    <UserMessage />
  </>
);

export default AppHeader;
